import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { RiStarSmileLine } from 'react-icons/ri';
import { Rating } from '@mui/material';
import { PiInfoFill } from 'react-icons/pi';
import DemoQuestions from './questions.json';
import Question from './Question';
import QuestionFormInstance from './QuestionForm';
import apiService from 'services/apiService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './style.css';

function adjustNumber(number) {
  let num = number + 1;
  let stringNum = `${num}`;
  if (stringNum.length === 1) {
    return `0${num}`;
  } else {
    return stringNum;
  }
}
function RatingQuestion({
  isRatingOpen,
  setIsRatingOpen,
  contractId,
  physicianId,
  managerId,
  review,
  showQ = false,
}) {
  const [questionCompleted, setQuestionCompleted] = useState(false);
  const [otherRating, setOtherRating] = useState('');
  const [staticDemoQuestions, setStaticDemoQuestions] = useState([]);
  const [ratingValue, setRatingValue] = useState(0);
  const [hasRated, setHasRated] = useState(false);
  const [question, setQuestion] = useState();

  const navigate = useNavigate();

  function toggleRating() {
    setIsRatingOpen(!isRatingOpen);
  }

  const QuestionForm = useMemo(() => {
    return new QuestionFormInstance(
      staticDemoQuestions,
      0,
      staticDemoQuestions.length,
      1
    );
  }, [staticDemoQuestions]);

  useEffect(() => {
    if (QuestionForm.startValue === 0 && staticDemoQuestions.length != 0) {
      setQuestion(new Question(QuestionForm.next().value));
    }
  }, [staticDemoQuestions]);

  useEffect(() => {
    setStaticDemoQuestions(DemoQuestions.questions);
  }, []);

  function physicianRatingHandler(rating, otherRating) {
    apiService
      .post('contracts/store/rating', {
        ratings: rating,
        remarks: otherRating,
        contract_id: contractId,
        physician_id: physicianId,
        hospital_manager_id: managerId,
      })
      .then((res) => {
        if (res?.original?.message) {
          toast.error(res?.original?.message);
          navigate('/Contracts');
        } else {
          toast.success(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);

        console.log('Error Rating Physician', err);
      });
  }

  useEffect(() => {
    if (showQ == true) {
      setQuestionCompleted(true);
    }
  }, [showQ]);

  console.log('staticDemoQuestions', review, setIsRatingOpen);

  return (
    <Modal
      isOpen={isRatingOpen}
      toggle={toggleRating}
      centered
      className="max-w-[412px]"
      cssModule={{ 'modal-content': 'modal-content-for-rating ' }}
    >
      <ModalHeader
        className="max-w-[412px]"
        cssModule={{ 'modal-title': 'modal-title-for-rating' }}
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <RiStarSmileLine
              height={19}
              width={20}
              className={`self-center box-content ${
                questionCompleted ? ' p-2.5 border rounded-full' : ''
              } `}
            />
            <h3
              className={`font-medium text-base m-0 ${
                questionCompleted ? 'flex flex-col' : ''
              } `}
            >
              Rate your visiting doctor
              {questionCompleted && (
                <span className="font-normal text-sm text-[#525866]">
                  How would you rate his experience.
                </span>
              )}
            </h3>
          </div>
          {!questionCompleted && (
            <p className="text-xs font-normal m-0 text-[#868C98] ">
              Question {QuestionForm.startValue}/
              {QuestionForm.questionArray.length}
            </p>
          )}
        </div>
      </ModalHeader>
      <ModalBody className="max-h-[460px] max-w-[412px] overflow-y-scroll scrollbar-thin scrollbar-thumb-[#E6E5E5] scrollbar-track-[#f9f9f9]">
        {!questionCompleted && (
          <section className="flex flex-col items-center">
            <div className="font-medium text-base py-2 px-[14px] text-[#375DFB] bg-[#EBF1FF] rounded-full">
              {adjustNumber(question?.questionNumber)}
            </div>
            <h3 className="text-base font-medium m-0">
              {question?.questionTitle}
            </h3>
            <p className="text-xs font-normal text-[#525866] text-center ">
              {question?.questionText}
            </p>
            <Rating
              value={ratingValue}
              onChange={(_, newValue) => {
                setRatingValue(newValue);
                let answerQuestion = question.setRating(newValue);
                setHasRated(true);
                QuestionForm.addAnswerQuestion(answerQuestion);
              }}
              sx={{
                justifyContent: 'space-between',
                width: '100%',
                border: '1px solid #E2E4E9',
                borderRadius: '12px',
                '& > label': {
                  paddingRight: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  borderRight: '1px solid #E2E4E9',
                  marginLeft: '-24px',
                },
                '& > label:last-of-type': {
                  borderRight: 'none',
                  display: 'none',
                },
                '& > label:nth-last-of-type(2)': {
                  borderRight: 'none',
                },
                '& > label:first-of-type': {
                  marginLeft: '24px',
                  paddingRight: '10px',
                },
              }}
            />
          </section>
        )}

        {questionCompleted && (
          <>
            <section className="flex flex-col items-center">
              <ul className="w-full px-2">
                {QuestionForm.answeredQuestions.map((ansQuestion) => (
                  <li className="flex justify-between my-2">
                    <div className="flex gap-1">
                      <p className=" font-medium font-base text-[#0A0D14] m-0 min-w-[115px] max-w-[118px]">
                        {ansQuestion.questionTitle}
                      </p>
                      <p className=" m-0 self-center text-[#CDD0D5] cursor-pointer">
                        <PiInfoFill height={20} width={20} />
                      </p>
                    </div>

                    <div>
                      <Rating readOnly value={ansQuestion.rating} />
                    </div>
                  </li>
                ))}
              </ul>
            </section>
            {showQ == true && (
              <section className="flex flex-col items-center">
                <ul className="w-full px-2">
                  {QuestionForm?.questionArray?.map((ansQuestion, index) => {
                    // Find the rating corresponding to the current question

                    const ratingObj = review?.ratings?.[0]?.ratings?.[index];

                    return (
                      <li key={index} className="flex justify-between my-2">
                        {/* Question Title + Info Icon */}
                        <div className="flex gap-1 items-center">
                          <p className="font-medium font-base text-[#0A0D14] m-0 min-w-[115px] max-w-[118px]">
                            {ansQuestion.title}
                          </p>

                          {/* Tooltip Icon */}
                          <div
                            data-tooltip-id={`tooltip-${index}`}
                            className="cursor-pointer"
                          >
                            <PiInfoFill size={20} className="text-[#CDD0D5]" />
                          </div>

                          {/* Tooltip Content 
                        <Tooltip id={`tooltip-${index}`} place="top" effect="solid">
                          {ansQuestion.description || "No additional info available"}
                        </Tooltip>*/}
                        </div>

                        {/* Rating Component */}
                        <div>
                          <Rating readOnly value={ratingObj || 0} />
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </section>
            )}
            {showQ == false && (
              <div class="flex flex-col space-y-2">
                <label
                  for="other-rating"
                  class="text-sm font-medium text-gray-700"
                >
                  Remarks (Optional)
                </label>
                <textarea
                  id="other-rating"
                  name="other-rating"
                  rows="4"
                  maxLength={500}
                  class="p-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="Enter your rating here..."
                  value={otherRating}
                  onChange={(e) => setOtherRating(e.target.value)}
                ></textarea>

                <div className="text-sm text-gray-500">
                  {otherRating.length} / 500 characters
                </div>
              </div>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter className="max-w-[412px]">
        {!questionCompleted && (
          <button
            className={`w-full bg-white border text-[#525866] font-medium text-sm p-2 rounded-lg ${
              !hasRated ? 'cursor-not-allowed' : ''
            } `}
            style={{ cursor: !hasRated ? 'not-allowed' : 'pointer' }}
            onClick={() => {
              if (ratingValue) {
                setRatingValue(0);
                let newQuestion = QuestionForm.next();
                setQuestionCompleted(newQuestion.done);
                if (!newQuestion.done) {
                  setQuestion(new Question(newQuestion.value));
                }
                setHasRated(false);
              }
            }}
          >
            Next Question
          </button>
        )}
        {questionCompleted && (
          <div className="flex w-full gap-2 ">
            <button
              className="font-medium text-sm text-[#525866] w-full border rounded-lg p-2"
              onClick={() => {
                setIsRatingOpen(false);
              }}
            >
              Cancel
            </button>

            {showQ == false && (
              <button
                className="font-medium text-sm text-white w-full border rounded-lg bg-[#375DFB] p-2"
                onClick={() => {
                  physicianRatingHandler(
                    QuestionForm.answeredQuestions.map(
                      (ansQuestion) => ansQuestion.rating
                    ),
                    otherRating
                  );

                  setIsRatingOpen(false);
                }}
              >
                Submit
              </button>
            )}
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default RatingQuestion;
